import { C } from "../theme/colors";
import Section from "../components/Section";
import PageHero from "../components/PageHero";

export default function ObjectivesPage() {
  const objectives = [
    {title:"Consolidate Existing Research",desc:"Identify all research collaborative projects by faculty across BITS Pilani campuses with relevance to national security."},
    {title:"Stakeholder Engagement",desc:"Interact with stakeholders and assimilate their operational field challenges, technology challenges, and skill gaps."},
    {title:"Internal Innovation",desc:"Brainstorm among faculty, research scholars, and students to harness innovative technology ideas."},
    {title:"International Benchmarking",desc:"Study the international scenario, evolve the gaps with respect to the domestic scenario, and work out a road map."},
    {title:"Professional Certification",desc:"Design and conduct certification courses to enhance skill sets of working professionals across domains."},
    {title:"Startup Incubation",desc:"Encourage and support young entrepreneurs in incubating start-ups that translate developed technologies into products."},
  ];
  return (
    <div className="page-fade">
      <PageHero title="Objectives" tag="Strategic Goals" subtitle="Six pillars guiding CRENS toward building a self-reliant national security research ecosystem."/>
      <Section>
        <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:18}} className="grid-2">
          {objectives.map((o,i) => (
            <div key={i} className="card" style={{padding:28,display:"flex",gap:20,alignItems:"flex-start"}}>
              <div style={{width:44,height:44,borderRadius:10,background:C.accent,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontFamily:"Arial,Helvetica,sans-serif",fontWeight:700,fontSize:15,color:C.blue}}>{String(i+1).padStart(2,"0")}</div>
              <div>
                <div style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:16,fontWeight:600,color:C.navyDark,marginBottom:8}}>{o.title}</div>
                <p className="body" style={{margin:0,fontSize:14,lineHeight:1.8}}>{o.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}
